/* Naksh shared helpers: lead logging to Google Sheets, WhatsApp links, refs, toast, add-to-cart.
   Config comes from the Naksh footer section: window.NakshConfig = { wa, sheet, consent }.
   Cart: dispatches Horizon's own CartLinesUpdateEvent so the native cart drawer and count
   bubble update — this store keeps Horizon's cart, not a separate Naksh drawer. */
import { CartLinesUpdateEvent } from '@shopify/events';
(function () {
  if (window.Naksh) return;
  var cfg = function () { return window.NakshConfig || {}; };
  var MAX = 1000;

  /* Trim and cap length. Formula-injection escaping happens once, in the Apps Script. */
  function clean(v) { return v == null ? '' : String(v).trim().slice(0, MAX); }
  function digits(v) { return String(v || '').replace(/\D/g, ''); }

  /* Reference code: keeps a Swatch Box ?src= code, else builds WEB-<pincode>-<random>. */
  function ref(text) {
    var src = '';
    try { src = (new URLSearchParams(location.search).get('src') || '').replace(/[^A-Za-z0-9\-_]/g, '').slice(0, 40); } catch (e) {}
    if (src) return src;
    var pin = (String(text || '').match(/\b\d{6}\b/) || ['000000'])[0];
    return 'WEB-' + pin + '-' + Math.random().toString(36).slice(2, 6).toUpperCase();
  }

  /* Fire-and-forget POST to the Apps Script web app. text/plain avoids a CORS preflight. */
  function log(type, fields) {
    var url = cfg().sheet;
    var payload = { lead_type: type, page: location.pathname + location.search, submitted_at: new Date().toISOString() };
    Object.keys(fields || {}).forEach(function (k) {
      var v = fields[k];
      payload[k] = Array.isArray(v) ? clean(v.join(', ')) : clean(v);
    });
    if (!url) { console.warn('[Naksh] Sheet URL not set in the Naksh footer section; lead not logged.', payload); return Promise.resolve(false); }
    try {
      return fetch(url, { method: 'POST', mode: 'no-cors', keepalive: true, headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: JSON.stringify(payload) })
        .then(function () { return true; }, function () { return false; });
    } catch (e) { return Promise.resolve(false); }
  }

  function waUrl(text, number) {
    var n = digits(number || cfg().wa);
    return 'https://wa.me/' + n + (text ? '?text=' + encodeURIComponent(String(text).slice(0, 1500)) : '');
  }
  /* Must be called synchronously inside a click/submit handler or pop-up blockers stop it. */
  function openWa(text, number) {
    var u = waUrl(text, number);
    var w = window.open(u, '_blank', 'noopener');
    if (!w) location.href = u;
  }

  function toast(msg) {
    var el = document.getElementById('nk-toast');
    if (!el) { el = document.createElement('div'); el.id = 'nk-toast'; el.className = 'nk-toast'; el.setAttribute('role', 'status'); document.body.appendChild(el); }
    el.textContent = msg; el.hidden = false; clearTimeout(toast.t);
    toast.t = setTimeout(function () { el.hidden = true; }, 2600);
  }

  function money(cents) {
    var n = cents / 100;
    var s = n % 1 === 0 ? n.toLocaleString('en-IN') : n.toLocaleString('en-IN', { minimumFractionDigits: 2 });
    return (cfg().moneyFormat || '₹{{amount}}').replace(/\{\{\s*\w+\s*\}\}/, s);
  }

  /* Add to cart, then dispatch Horizon's native cart-update event so its own cart drawer
     opens and the count bubble updates — same pattern used across every Naksh PDP. */
  function addToCart(variantId, qty) {
    var root = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
    var deferred = CartLinesUpdateEvent.createPromise();
    document.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + variantId, quantity: qty || 1 }],
      promise: deferred.promise
    }));
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) {
        deferred.resolve({ detail: { source: 'naksh', itemCount: j.item_count, didError: false } });
        return j;
      })
      .catch(function (err) {
        deferred.reject(err instanceof Error ? err : new Error((err && err.message) || 'Cart add failed'));
        throw err;
      });
  }

  /* Simple modal helper with focus return and Escape. */
  var openModal = null, lastFocus = null;
  function showModal(modal, scrim) {
    hideModal(true); lastFocus = document.activeElement; openModal = { m: modal, s: scrim };
    if (scrim) scrim.hidden = false; modal.hidden = false;
    var f = modal.querySelector('input,select,textarea,button'); if (f) f.focus();
  }
  function hideModal(silent) {
    if (!openModal) return; openModal.m.hidden = true; if (openModal.s) openModal.s.hidden = true; openModal = null;
    if (!silent && lastFocus) try { lastFocus.focus(); } catch (e) {}
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hideModal(); });

  window.Naksh = { log: log, waUrl: waUrl, openWa: openWa, ref: ref, toast: toast, money: money, addToCart: addToCart, digits: digits, showModal: showModal, hideModal: hideModal, cfg: cfg };
})();
